import { useParams } from "react-router"

import { ENDPOINTS } from "@/constants/endpoints"
import { FILTERS } from "@/constants/filters"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type { Ticket } from "@/types/ticketTypes"

export const useTicketsData = () => {
  return useGenericQuery<Ticket[]>({
    keys: QUERY_KEYS.tickets.index(),
    apiEndpoint: ENDPOINTS.tickets.index(),
    filterName: FILTERS.tickets.index(),
    paginated: true,
  })
}
export const useSingleTicketData = (id: number) => {
  const { chatId } = useParams()
  return useGenericQuery<Ticket>({
    enabled: chatId != "new",
    keys: QUERY_KEYS.tickets.show(id),
    apiEndpoint: ENDPOINTS.tickets.show(id),
  })
}
